// extracted by mini-css-extract-plugin
export default {"container":"edit-menu_container__mENng"};